/**
 * QA-64: steps a mission's agent left for a person ("NEEDS A PERSON: run npm publish") wait in the
 * Inbox too, not only on the mission and its item, until a person closes the mission as done.
 */
import { ORGUS_ACTOR_ID } from '@orgus/protocol';
import type { Id, Mission } from '@orgus/protocol';

export interface PersonStep {
  missionId: Id;
  title: string;
  step: string;
  projectId: Id;
  at: number;
}

export function personSteps(missions: readonly Pick<Mission, 'id' | 'title' | 'projectId' | 'report' | 'closed'>[]): PersonStep[] {
  const out: PersonStep[] = [];
  for (const m of missions) {
    const steps = m.report?.needsPerson ?? [];
    if (!steps.length) continue;
    // A person who closed it as done took the step (the hub's rule, missions index QA-29/QA-62).
    if (m.closed?.as === 'done' && m.closed.by !== ORGUS_ACTOR_ID) continue;
    if (m.closed?.as === 'stopped') continue;
    for (const step of steps) out.push({ missionId: m.id, title: m.title, step, projectId: m.projectId, at: m.report!.at });
  }
  return out.sort((a, b) => a.at - b.at);
}
